var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "PageHeader",
        { attrs: { line: false } },
        [
          _c("el-input", {
            directives: [
              {
                name: "debounce",
                rawName: "v-debounce",
                value: _vm.onSearch,
                expression: "onSearch",
              },
            ],
            attrs: {
              size: "mini",
              "prefix-icon": "el-icon-search",
              placeholder: "Search",
              clearable: "",
            },
            on: { clear: _vm.onSearch },
            model: {
              value: _vm.searchVal,
              callback: function ($$v) {
                _vm.searchVal = $$v
              },
              expression: "searchVal",
            },
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.tableLoading,
              expression: "tableLoading",
            },
          ],
          ref: "table",
          attrs: { data: _vm.tableData, "element-loading-text": "Loading..." },
          on: { "sort-change": _vm.onSortChange },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "No.",
              width: "115",
              sortable: "custom",
              prop: "No",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "Document Title",
              "min-width": "150",
              sortable: "custom",
              prop: "DocumentTitle",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "Request Date",
              width: "150",
              sortable: "custom",
              prop: "RequestDate",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-wrap" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 25, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }